import { render, staticRenderFns } from "./LabeledTitle.vue?vue&type=template&id=c9b3a0ce&"
import script from "./LabeledTitle.vue?vue&type=script&lang=js&"
export * from "./LabeledTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports